module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-mfa-panel",
    attrs: {
      "datas": _vm.connects,
      "items": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm,
      "onSubmit": _vm.onSubmitForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Unbind MFA")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd43df50"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/model/account-close-mfa.vue
// module id = 624
// module chunks = 4 5 6